import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusAttendeeTickets } from '@shared/constants/constants';

@Pipe({
    name: 'attendeeTicketStatusType'
})
export class AttendeeTicketStatusTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number): string {
        let result = '';
        const itemsStatusAttendeeTickets = StatusAttendeeTickets(this.translation);
        if (itemsStatusAttendeeTickets){
            const selected = itemsStatusAttendeeTickets.find(x => x.id === value);
            if (selected){
                result = selected.text;
            }
        }

        return result;
    }
}
